import { useContext, useEffect, useState } from "react";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@material-ui/core";

import { EditOutlined } from "@material-ui/icons";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import useProdutoController from "../controllers/ProdutoController";
import { ProdutoContext } from "../contexts/ProdutoContext";
import { notify } from "../../../../utils/notify";
import TableDefault from "../../../../components/grid/TableDefault";
import { TableContent } from "../styles/Produto";
import Card from "../../../../components/cards/Card";
import SelectErp from "../../../../components/basics/SelectErp";
import MaskService from "../../../../utils/mask/maskService";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ShuffleIcon from "@material-ui/icons/Shuffle";

const columns = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
  },
  {
    id: "codigobarras",
    label: "Cod. Barras",
  },
  {
    id: "qtdvenda",
    label: "Qtd. Venda",
  },
  {
    id: "unidade_medida",
    label: "UND",
  },
  {
    id: "percentual_desconto",
    label: "Desconto (%)",
    format: (item) => item.percentual_desconto ?? "-",
  },
];

export default function ModalProdutoCodigoBarraAdicional({
  open,
  setOpen,
  barCodeAdditional,
  setBarCodeAdditional,
  idestoque,
  barCodeFromModal,
}) {
  const { listUnits, stockLocations, setErrors } = useContext(ProdutoContext);
  const { handleRemoveItemTable, handleCreateBarCode } = useProdutoController();

  const [rowEdit, setRowEdit] = useState({});
  const [barCodeModal, setBarCodeModal] = useState("");
  const [qtdSaleModal, setQtdSaleModal] = useState("0");
  const [percentDescontModal, setPercentDescontModal] = useState("0,00");
  const [dataTable, setDataTable] = useState([]);
  const [errorsModal, setErrorsModal] = useState({});
  const [aditionalUnity, setAditionalUnity] = useState(null);

  useEffect(() => {
    const newArr = barCodeAdditional.map((item, index) => ({
      ...item,
      acoes: (
        <SpeedDialErp
          actions={[
            {
              icon: <EditOutlined />,
              name: "Editar",
              action: () => handleEdit(item.id || null, index, item),
            },
            {
              icon: <DeleteOutlined />,
              name: "Excluir",
              action: () =>
                handleRemoveItemTable(
                  setDataTable,
                  setBarCodeAdditional,
                  barCodeAdditional,
                  index
                ),
            },
          ]}
        />
      ),
    }));

    setDataTable(newArr);
    // eslint-disable-next-line
  }, [barCodeAdditional]);

  const handleCloseModal = () => {
    setErrors((old) => ({
      ...old,
      additionalBarCode: false,
    }));

    setOpen(false);
  };

  const handleEdit = (id, index, item) => {
    setRowEdit({ id, index });

    setBarCodeModal(item.codigobarras || "");
    setQtdSaleModal(
      MaskService.toMask("decimal", parseFloat(item.qtdvenda || "0").toFixed(2))
    );
    setPercentDescontModal(
      MaskService.toMask(
        "decimal",
        parseFloat(item.percentual_desconto || "0").toFixed(2)
      )
    );
    setAditionalUnity(
      listUnits.find((el) => el.descricao === item.unidade_medida) || null
    );

    document
      .getElementById("modal-bar-code")
      .scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleChangeBarCode = () => {
    if (!barCodeModal) {
      setErrorsModal({ barCodeModal: "Campo obrigatório" });
      return notify("Verifique se os campos estão preenchidos corretamente.");
    }

    let repeatedCode = false;

    barCodeAdditional.forEach((additionalCode) => {
      if (additionalCode.codigobarras === barCodeModal) repeatedCode = true;
    });

    stockLocations.forEach((stock) => {
      if (stock.codigobarras === barCodeModal) repeatedCode = true;
    });

    if (barCodeFromModal === barCodeModal) repeatedCode = true;

    if (
      repeatedCode &&
      !((rowEdit.index || rowEdit.index === 0) && rowEdit.index !== -1)
    ) {
      setErrorsModal({ barCodeModal: "Código repetido" });
      return notify("Os códigos de barras precisam ser diferentes.");
    }

    const body = {
      codigobarras: barCodeModal.replaceAll(" ", ""), // max 20
      qtdvenda: MaskService.removeMaskDecimal(qtdSaleModal),
      percentual_desconto: MaskService.removeMaskDecimal(percentDescontModal), //12,2
      unidade_medida: aditionalUnity?.descricao ?? "",
      idestoque: idestoque ?? null,
    };

    if (rowEdit.index || rowEdit.index === 0) {
      body.id = rowEdit.id || null;

      if (rowEdit.index !== -1) {
        const copy = [...barCodeAdditional];
        copy[rowEdit.index] = body;
        setBarCodeAdditional(copy);
      }
    } else {
      setBarCodeAdditional((current) => [...current, body]);
    }

    setBarCodeModal("");
    setQtdSaleModal("0");
    setPercentDescontModal("0,00");
    setRowEdit({});
    setErrorsModal({});
    setAditionalUnity(null);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Código de Barra Adicional
        </DialogTitle>
        <DialogContent id="modal-bar-code">
          <Grid container spacing={2}>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={10}>
                  <TextFieldErp
                    error={!!errorsModal.barCodeModal || false}
                    helperText={errorsModal.barCodeModal || ""}
                    label="Código de Barras"
                    maxLength={20}
                    value={barCodeModal}
                    setValue={setBarCodeModal}
                  />
                </Grid>
                <Tooltip title="Gerar Código">
                  <Grid item xs={2}>
                    <Btn
                      label={<ShuffleIcon />}
                      bgcolor="tertiary"
                      onClick={() => handleCreateBarCode(setBarCodeModal)}
                    />
                  </Grid>
                </Tooltip>
                <Grid item xs={12}>
                  <TextFieldErp
                    label="Quantidade Venda"
                    maxLength={9}
                    value={qtdSaleModal}
                    setValue={setQtdSaleModal}
                    mask="decimal"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextFieldErp
                    label="Percentual Desconto (%)"
                    maxLength={14}
                    value={percentDescontModal}
                    setValue={setPercentDescontModal}
                    mask="decimal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <SelectErp
                    label="Unidade de Medida"
                    optionsList={listUnits}
                    value={aditionalUnity}
                    setValue={setAditionalUnity}
                    descriptionField="descricao"
                  />
                </Grid>
              </Grid>
            </Card>
            <Grid item flex={1}>
              <Btn
                bgcolor="primary"
                label={
                  typeof rowEdit.index === "number" ? "Salvar" : "Adicionar"
                }
                onClick={handleChangeBarCode}
              />
            </Grid>
            <Grid item xs={12}>
              <TableContent>
                <Grid item xs={12}>
                  <TableDefault
                    columns={columns}
                    values={dataTable}
                    tableTitle=""
                    rowsPerPage={3}
                  />
                </Grid>
              </TableContent>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Fechar" bgcolor="tertiary" onClick={handleCloseModal} />
        </DialogActions>
      </Dialog>
    </>
  );
}
